import { useEffect, useRef, useState } from "react";

/**
 * useInView — element jab bhi viewport mein aaye/jaaye, `inView` state
 * ko continuously update karta rehta hai (ek-baar wala nahi, balki
 * har enter/exit par).
 *
 * Isse video-heavy pages par yeh kaam ho paata hai:
 *  - element viewport ke paas aaya  -> video autoplay
 *  - element viewport se bahar gaya -> video pause (CPU/battery bachane ke liye)
 */
export default function useInView(options) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    // Purane browsers ya SSR mein IntersectionObserver na ho to seedha true kar do
    if (typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { rootMargin: "150px", threshold: 0.25, ...options },
    );

    observer.observe(node);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [ref, inView];
}
